import React from "react";
import { Box, Paper } from "@material-ui/core";
import { MaterialSpecsTable } from "pages/MaterialSpecs/components";

export const MaterialSpecsInfo = () => {
    return (
        <Box component={Paper} overflow="hidden" height="100%">
            <MaterialSpecsTable />
        </Box>
    );
};
